import { Link } from "react-router-dom";
import { Mail, Phone, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { BUSINESS } from "../data/site";
import { CITIES } from "../data/cities";

const cols = [
  { h: "Residential", links: [["Interior painting", "/residential/interior"], ["Exterior painting", "/residential/exterior"], ["Cabinets & condos", "/residential/cabinets"]] },
  { h: "Commercial", links: [["Offices", "/commercial/offices"], ["Hospitality & retail", "/commercial/hospitality"], ["High-rise & multi-unit", "/commercial/high-rise-multi-unit"]] },
  { h: "Company", links: [["Our process", "/our-process"], ["Projects", "/projects"], ["About Ilias", "/about"], ["Reviews", "/reviews"], ["Service areas", "/service-areas"], ["Contact", "/contact"]] },
];

export const Footer = () => (
  <footer className="relative bg-navy-900 pb-28 pt-20 text-slate-300 lg:pb-12" data-testid="site-footer">
    <div className="container-x">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Logo />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">Toronto's dust-free painting company. 30 years of residential and commercial work across the GTA, cottage country and Ontario. Licensed & insured.</p>
          <div className="mt-6 space-y-3 text-sm">
            <a href={BUSINESS.phoneHref} className="flex items-center gap-3 font-semibold text-white hover:text-flame" data-testid="footer-phone-link"><Phone className="h-4 w-4 text-flame" /> {BUSINESS.phone}</a>
            <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-3 hover:text-flame" data-testid="footer-email-link"><Mail className="h-4 w-4 text-flame" /> {BUSINESS.email}</a>
            <p className="flex items-center gap-3"><Clock className="h-4 w-4 text-flame" /> {BUSINESS.hours}</p>
          </div>
        </div>
        {cols.map((c) => (
          <div key={c.h} className="lg:col-span-2">
            <p className="eyebrow text-slate-400">{c.h}</p>
            <ul className="mt-5 space-y-3 text-sm">
              {c.links.map(([l, to]) => <li key={to}><Link to={to} className="transition-colors hover:text-flame">{l}</Link></li>)}
            </ul>
          </div>
        ))}
        <div className="lg:col-span-2">
          <p className="eyebrow text-slate-400">Get started</p>
          <Link to="/book" className="btn-primary mt-5 w-full" data-testid="footer-book-btn">Book Free Assessment</Link>
        </div>
      </div>
      <div className="mt-16 border-t border-white/10 pt-8 text-xs leading-relaxed text-slate-400">
        <p><span className="font-semibold text-slate-300">Service areas:</span>{" "}
          {CITIES.map((c, i) => (
            <span key={c.slug}><Link to={`/painters/${c.slug}`} className="hover:text-flame">{c.name.replace(/^the /, "the ")}</Link>{i < CITIES.length - 1 ? ", " : ". "}</span>
          ))}
          Commercial projects across Ontario.</p>
        <p className="mt-4">© {new Date().getFullYear()} Amora Painting. The Amora Dust-Free Promise™ and The Amora Colour & Scope Visit™.</p>
      </div>
    </div>
  </footer>
);

export const MobileCallBar = () => (
  <div className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy/95 p-3 backdrop-blur-xl lg:hidden" data-testid="sticky-call-bar">
    <div className="grid grid-cols-2 gap-2">
      <a href={BUSINESS.phoneHref} className="flex items-center justify-center gap-2 rounded-full bg-white py-3 text-sm font-bold text-navy" data-testid="sticky-call-bar-phone-link">
        <Phone className="h-4 w-4" /> Call {BUSINESS.phone}
      </a>
      <Link to="/book" className="flex items-center justify-center rounded-full bg-flame py-3 text-sm font-bold text-navy" data-testid="sticky-call-bar-book-link">Book Free Visit</Link>
    </div>
  </div>
);
